export const INVALID_STORAGE_ERROR =
  'The transaction could not be completed. Please try logging in again. If the issue persists, contact Tech Support for assistance';

export const EMPTY_CPT_CODE_FIELDS_ERROR =
  "Can't leave empty the fields Payer ID, Clinic ID or Place of Service";

export const LOADING_SPINNER_SIZE = 20; // Standard size for loading indicators in RPM components
